import { render, staticRenderFns } from "./PolicyPanel.vue?vue&type=template&id=48905e4d&scoped=true&"
import script from "./PolicyPanel.vue?vue&type=script&lang=js&"
export * from "./PolicyPanel.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPanel.vue?vue&type=style&index=0&id=48905e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48905e4d",
  null
  
)

export default component.exports